import React, { useState } from 'react';
import './style.scss';
import clsx from 'clsx';
import { GridIcon, ListIcon } from '../icons';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';

const CardsListHeader = ({ heading, text, isGrid, setIsGrid, disableSwitch, darkMode }) => {
  const shouldRenderTitle = !!heading?.value;
  const shouldRenderText = !!text?.value;

  if (!shouldRenderTitle && !shouldRenderText) return null;

  return (
    <div
      className={clsx(
        'cards-list-header-wrapper flex-it flex-align-item-start',
        'content',
        darkMode && 'cards-list-header-wrapper-dark'
      )}
    >
      <div className="cards-list-header">
        {shouldRenderTitle && (
          <div className="cl-header-title">
            <Text field={heading} />
          </div>
        )}
        {shouldRenderText && <RichText className="cl-header-text" field={text} />}
      </div>
      {!disableSwitch && <ViewControls isGrid={isGrid} setIsGrid={setIsGrid} darkMode={darkMode} />}
    </div>
  );
};

const ViewControls = ({ isGrid, setIsGrid, darkMode }) => {
  const [hover, setHover] = useState(false);

  const handleClick = (newIsGrid) => {
    setIsGrid(newIsGrid);
    setHover(false);
  };

  const handleMouseEnter = (hoveringGrid, isGrid) => {
    if (isGrid === hoveringGrid) return;
    setHover(true);
  };

  const handleMouseLeave = () => {
    setHover(false);
  };

  return (
    <div className="cards-list-view-controls">
      <div
        className={clsx(
          'clvc-button',
          isGrid && 'clvc-button-active',
          hover && 'clvc-button-hovered'
        )}
        onClick={() => handleClick(true)}
        onMouseEnter={() => handleMouseEnter(true, isGrid)}
        onMouseLeave={() => handleMouseLeave()}
      >
        <GridIcon color={darkMode && isGrid ? '#FFF' : '#7EACFF'} />
        <div className="clvc-button-text">Grid</div>
      </div>
      <div
        className={clsx(
          'clvc-button',
          !isGrid && 'clvc-button-active',
          hover && 'clvc-button-hovered'
        )}
        onClick={() => handleClick(false)}
        onMouseEnter={() => handleMouseEnter(false, isGrid)}
        onMouseLeave={() => handleMouseLeave()}
      >
        <ListIcon color={darkMode && !isGrid ? '#FFF' : '#7EACFF'} />
        <div className="clvc-button-text">List</div>
      </div>
    </div>
  );
};

export default CardsListHeader;
